import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TTaskStatus } from 'entities/task/model/types/tasks';
import { IAddModalSchemaState } from 'entities/modal/model/types/addModalSchema';
import { IModalAttachment } from '../../../../entities/attachment/model/IModalAttachment.interface';

const initialState: IAddModalSchemaState = {
    isCompleted: false,
    title: '',
    description: '',
    date: '',
    tags: [],
    color: '#9DA1AC',
    status: 'is_waiting',
    observerIds: [],
    estimateId: '',
    executorId: '',
    projectId: '',
    attachments: [],

    isLoading: false,
    error: null as string | null,
};

export const addModalSlice = createSlice({
    name: 'addModal',
    initialState,
    reducers: {
        changeError: (state, { payload }: PayloadAction<string>) => {
            state.error = payload;
        },
        changeIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload;
        },
        changeIsCompleted: (state, { payload }: PayloadAction<boolean>) => {
            state.isCompleted = payload;
        },
        changeModalTitle: (state, { payload }: PayloadAction<string>) => {
            state.title = payload;
        },
        changeModalDescription: (state, { payload }: PayloadAction<string>) => {
            state.description = payload;
        },
        changeModalDate: (state, { payload }: PayloadAction<string>) => {
            state.date = payload;
        },
        changeModalTags: (state, { payload }: PayloadAction<string[]>) => {
            state.tags = payload;
        },
        changeModalColor: (state, { payload }: PayloadAction<string>) => {
            state.color = payload;
        },
        changeObserverIds: (state, { payload }: PayloadAction<number[]>) => {
            state.observerIds = payload;
        },
        removeObserverIds: (state, { payload }: PayloadAction<number>) => {
            state.observerIds = state.observerIds.filter((id) => id !== payload);
        },
        changeEstimateId: (state, { payload }: PayloadAction<number | null>) => {
            state.estimateId = payload;
        },
        changeExecutorId: (state, { payload }: PayloadAction<number | null>) => {
            state.executorId = payload;
        },
        changeProjectId: (state, { payload }: PayloadAction<number | null>) => {
            state.projectId = payload;
        },
        changeAddModalAttachments: (state, { payload }: PayloadAction<IModalAttachment[]>) => {
            state.attachments = payload;
        },
        toggleModalStatus: (state, { payload }: PayloadAction<TTaskStatus>) => {
            state.status = payload;
        },
        resetModalData: (state) => {
            state.isLoading = false;
            state.error = null;
            state.isCompleted = false;
            state.title = '';
            state.description = '';
            state.date = '';
            state.tags = [];
            state.color = '#9DA1AC';
            state.status = 'is_waiting';
            state.observerIds = [];
            state.estimateId = '';
            state.executorId = '';
            state.projectId = '';
            state.attachments = [];
        },
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(createCustomTask.pending, (state) => {
    //             state.isLoading = true;
    //             state.error = null;
    //         })
    //         .addCase(createCustomTask.fulfilled, (state, action) => {
    //             state.isLoading = false;
    //             state.error = null;
    //         })
    //         .addCase(createCustomTask.rejected, (state, { payload }) => {
    //             state.isLoading = false;
    //             state.error = '';
    //         });
    // },
});

export const {
    changeError,
    changeIsLoading,
    changeAddModalAttachments,
    changeExecutorId,
    changeIsCompleted,
    changeEstimateId,
    changeModalDescription,
    changeModalColor,
    changeModalDate,
    changeModalTags,
    changeObserverIds,
    changeModalTitle,
    changeProjectId,
    removeObserverIds,
    toggleModalStatus,
    resetModalData,
} = addModalSlice.actions;
export const { reducer: addModalReducer } = addModalSlice;
